import {ScreenService} from 'services/screen';
import {canChangeOrientation} from './canChangeOrientation';
import {onOrientationChange} from './onOrientationChange';
import {orientationOf} from './orientationOf';
import {sizeOf} from './sizeOf';
import {dpiOf} from './dpiOf';

export const screenService: ScreenService = {
  dpiOf,
  sizeOf,
  orientationOf,
  onOrientationChange,
  canChangeOrientation,
};
